import store from '../store'
import axiosCore from "axios";
export default class ApiEvaliv {
  static async getInstance(typeSdk) {
    if (!ApiEvaliv.instance) {
      /*const app = await store.getters.getFirebaseApp;
      const BioTimeConfSnap = await app.database.ref("BIO/Activos/"+typeSdk).once('value');
      //Assert_1.StrictAssert.ok(BioTimeConfSnap.exists(), Model_1.ErrorInModel("ApiBioTime", null, "No existe la configuracion para el api de biotime"));
      const BioTimeConf = BioTimeConfSnap.val();*/
      ApiEvaliv.instance = axiosCore.default.create({
        baseURL: "https://ccfn-pargolfsolutions.web.app/",
       //baseURL:'http://10.147.18.67:50045/pargolfsolutions-e4659/us-central1/',
        headers: {"vary": "x-fh-requested-host, accept-encoding, cookie, authorization" },
      });
      ApiEvaliv.instance.interceptors.request.use(async function (config) {
        if (!config.headers["Authorization"]) {
          const user = await store.state.FirebaseApp.firebaseApp.auth.getCurrentUserFirstTime;
          if (user) {
            if (!store.state.FirebaseApp.firebaseApp.auth.getAuth(store.state.FirebaseApp.firebaseApp.mainApp).currentUser) {
              await store.state.FirebaseApp.firebaseApp.auth.getAuth(store.state.FirebaseApp.firebaseApp.mainApp).updateCurrentUser(user)
            }
            const token = await user.getIdTokenResult();
            config.headers["Authorization"] = `Bearer ${user.accessToken}`;
          }
          //config.headers["Authorization"] = `Bearer ${tokenRes.data.access_token}`;
        }
        return config;
      });
      /*ApiBioTime.instance.interceptors.request.use(async function (config) {
        if (!config.headers["Authorization"]) {
          const tokenRes = await ApiBioTime.instance.post("Auth/login", { username: BioTimeConf.user, password: BioTimeConf.pass }, { headers: { Authorization: "JWT" } });
          config.headers["Authorization"] = `Bearer ${tokenRes.data.access_token}`;
        }
        return config;
      });*/
      /*ApiBioTime.instance.interceptors.response.use((response) => {
        return response;
      }, async (error) => {
        const response = error.response;
        const config = error.config;
        if (response.status === 401 && config.headers["Authorization"] && !config._retriyed) {
          const newTokenRes = await ApiBioTime.instance.post("Auth/refresh", {
            token: config.headers["Authorization"],
          });
          config.headers["Authorization"] = `Bearer ${newTokenRes.data.access_token}`;
          config._retriyed = true;
          return Promise.resolve(axiosCore.default(config));
        }
        else {
          return Promise.reject(error);
        }
      });*/
    }
    return ApiEvaliv.instance;
  }
}
